/**
 * Cinna Bunny — Freedom Above Everything Tee launch offer
 *
 * IMPORTANT: this script controls DISPLAY ONLY. It has no power to grant a
 * discount — the code FREEDOM40 is validated by Shopify's checkout using the
 * rules set in Admin (product scope + 100-use cap). Editing this file or the
 * page's localStorage cannot make an expired/invalid code work at checkout.
 */
(function () {
  "use strict";

  // Section version: supports one or more ".cb-offer-instance" roots on the page
  // (each Shopify section gets a unique id), initializing each independently.
  var instances = document.querySelectorAll(".cb-offer-instance");
  if (!instances.length) return;
  instances.forEach(initInstance);

  function initInstance(root) {

  var STORAGE_KEY = "cb_offer_expiry_" + (root.id || "default"); // per-section-instance storage key
  var DURATION_MS = parseInt(root.getAttribute("data-duration-ms"), 10) || 300000; // 5 min
  var CODE = root.getAttribute("data-discount-code") || "FREEDOM40";

  var STATE = { UNCLAIMED: "unclaimed", ACTIVE: "active", EXPIRED: "expired" };

  var claimButtons = root.querySelectorAll(".cb-btn--claim");
  var copyButtons = root.querySelectorAll(".cb-btn--copy");
  var stickyBar = root.querySelector(".cb-sticky-bar");

  var minEls = root.querySelectorAll(".cb-timer-min");
  var secEls = root.querySelectorAll(".cb-timer-sec");
  var timerTextEls = root.querySelectorAll(".cb-timer-text"); // compact "MM:SS" used in bars

  var tickHandle = null;

  function pushEvent(name, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = Object.assign({ event: name, product_handle: root.dataset.productHandle || undefined }, extra || {});
    window.dataLayer.push(payload);
  }

  function getExpiry() {
    try {
      var v = window.localStorage.getItem(STORAGE_KEY);
      return v ? parseInt(v, 10) : null;
    } catch (e) {
      return null; // storage blocked (private mode edge cases) — degrade to "unclaimed" only, never fake-active
    }
  }

  function setExpiry(ts) {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(ts));
    } catch (e) {
      /* if storage is unavailable, the offer simply won't persist across reloads — no crash */
    }
  }

  function currentState() {
    var expiry = getExpiry();
    if (!expiry) return STATE.UNCLAIMED;
    return expiry > Date.now() ? STATE.ACTIVE : STATE.EXPIRED;
  }

  function setUI(state) {
    root.querySelectorAll(".cb-state-unclaimed").forEach(function (el) {
      el.hidden = state !== STATE.UNCLAIMED;
    });
    root.querySelectorAll(".cb-state-active").forEach(function (el) {
      el.hidden = state !== STATE.ACTIVE;
    });
    root.querySelectorAll(".cb-state-expired").forEach(function (el) {
      el.hidden = state !== STATE.EXPIRED;
    });
    if (stickyBar) stickyBar.hidden = false; // sticky bar itself always shows once claimable; it just switches inner state
  }

  function formatMMSS(ms) {
    var totalSec = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(totalSec / 60);
    var s = totalSec % 60;
    return {
      m: String(m).padStart(2, "0"),
      s: String(s).padStart(2, "0"),
    };
  }

  function renderTimer(remainingMs) {
    var t = formatMMSS(remainingMs);
    minEls.forEach(function (el) { el.textContent = t.m; });
    secEls.forEach(function (el) { el.textContent = t.s; });
    timerTextEls.forEach(function (el) { el.textContent = t.m + ":" + t.s; });
  }

  function stopTick() {
    if (tickHandle) {
      clearInterval(tickHandle);
      tickHandle = null;
    }
  }

  function startTick() {
    stopTick();
    tickHandle = setInterval(function () {
      var expiry = getExpiry();
      if (!expiry) { stopTick(); return; }
      var remaining = expiry - Date.now();
      if (remaining <= 0) {
        renderTimer(0);
        stopTick();
        setUI(STATE.EXPIRED);
        return;
      }
      renderTimer(remaining);
    }, 1000);
  }

  function claim() {
    if (currentState() !== STATE.UNCLAIMED) return; // already claimed or expired — no-op, cannot restart
    var expiry = Date.now() + DURATION_MS;
    setExpiry(expiry);
    setUI(STATE.ACTIVE);
    renderTimer(expiry - Date.now());
    startTick();
    pushEvent("cb_offer_claimed", { discount_code: CODE });
  }

  function copyCode(code) {
    var done = function (ok) {
      pushEvent("cb_discount_copied", { discount_code: code, success: ok });
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
    } else {
      // fallback for older browsers
      var tmp = document.createElement("textarea");
      tmp.value = code;
      tmp.style.position = "fixed";
      tmp.style.opacity = "0";
      document.body.appendChild(tmp);
      tmp.focus();
      tmp.select();
      var ok = false;
      try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
      document.body.removeChild(tmp);
      done(ok);
    }
  }

  // ---- wire up buttons ----
  claimButtons.forEach(function (btn) {
    btn.addEventListener("click", claim);
  });

  copyButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var code = btn.getAttribute("data-copy-text") || CODE;
      copyCode(code);
      var original = btn.textContent;
      btn.textContent = "COPIED";
      btn.classList.add("cb-copied");
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove("cb-copied");
      }, 1800);
    });
  });

  // ---- initial render on load ----
  var initial = currentState();
  setUI(initial);
  if (initial === STATE.ACTIVE) {
    renderTimer(getExpiry() - Date.now());
    startTick();
  } else if (initial === STATE.EXPIRED) {
    renderTimer(0);
  }

  // ---- "offer viewed" fires once, when the card scrolls into view ----
  var card = root.querySelector(".cb-offer-card");
  if (card && "IntersectionObserver" in window) {
    var seen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen) {
          seen = true;
          pushEvent("cb_offer_viewed");
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });
    io.observe(card);
  }

  // ---- best-effort Add to Cart tracking while offer is active ----
  // NOTE: Rise's exact Add to Cart form/button markup wasn't available for me to inspect.
  // This listens for a submit on any <form> containing a "/cart/add" action, which is the
  // standard Shopify pattern, and no-ops harmlessly if your theme's form differs.
  // Verify this fires in your theme (Scenario 6 in the test checklist) — adjust the selector
  // below if your Add to Cart button isn't inside such a form.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.action || "")) return;
    if (currentState() === STATE.ACTIVE) {
      pushEvent("cb_add_to_cart_with_offer", { discount_code: CODE });
    }
  }, true);

  } // end initInstance
})();
